module.exports = __webpack_public_path__ + "static/HR Portal Aufgabenliste-31bcb61eb96df6be47d2ca7ce1e53e87.jpg";